import { companyApiEndpoints } from '@/api/endpoints';
import { formatAntDDate } from '@/utils/common';
import { showToast } from '@/utils/toastMessage/ToastMessage';

/**
 * create  and edit handle api function
 * @param {*} data
 * @param {string} data.name
 * @param {string} data.address
 * @param {string}
 */
const handleAddCompanyAPI = async (data, setLoading, navigate) => {
  try {
    setLoading(true);
    const res = await companyApiEndpoints.create({
      ...data,
      photo: data?.photo[0]?.thumbUrl.split(',')[1] ?? null,
      financialYearStart: formatAntDDate(data?.financialYear[0]),
      financialYearEnd: formatAntDDate(data?.financialYear[1]),
    });

    if (res?.data?.response) {
      showToast(res.data.response, 'success');
    }
    navigate('/admin/dashboard/master/companies/', { replace: true });
  } catch (error) {
    if (error.response.data.error) {
      showToast(error.response.data.error[0], 'error');
      return;
    }

    showToast('Something went wrong!', 'error');

    throw new Error(error);
  } finally {
    setLoading(false);
  }
};

const handleEditCompanyAPI = async (id, data, setLoading, navigate) => {
  try {
    setLoading(true);
    const photo = data?.photo ? data?.photo[0]?.thumbUrl.split(',')[1] : null;

    const res = await companyApiEndpoints.update(id, {
      ...data,
      photo: photo,
      financialYearStart: formatAntDDate(data?.financialYear[0]),
      financialYearEnd: formatAntDDate(data?.financialYear[1]),
    });

    if (res?.data?.response) {
      showToast(res.data.response, 'success');
    }

    navigate('/admin/dashboard/master/companies/', { replace: true });
  } catch (error) {
    if (error?.response?.data?.error) {
      showToast(error?.response?.data?.error[0], 'error');
      return;
    }
    showToast('Something went wrong!', 'error');
    throw new Error(error);
  } finally {
    setLoading(false);
  }
};

const handleDeleteCompanyAPI = async (id, refresh) => {
  try {
    const res = await companyApiEndpoints.delete(id);

    if (res?.data?.response) {
      if (res?.data?.response) {
        showToast(res.data.response, 'success');
        refresh();
      }
    }
  } catch (error) {
    if (error.response.data.error) {
      showToast(error.response.data.error[0], 'error');
      return;
    } else {
      const errMessage =
        error.response?.data?.error?.[0] ?? error?.response?.data?.response;
      showToast(errMessage, 'error');
    }
    // showToast('Something went wrong!', 'error');
    throw new Error(error);
  }
};

export { handleAddCompanyAPI, handleEditCompanyAPI, handleDeleteCompanyAPI };
